import * as actions from "../actionTypes"

const initialState = {
    value: true,
}

export default function showSuggestedViews(state = initialState, action) {
    switch (action.type) {
        case actions.SET_SHOW_SUGGESTED_VIEWS: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
